import { useMemo } from 'react';
import { useFeatures } from 'utils/util/features';

export const useLevellingFramework = () => {
  const { isEnabled } = useFeatures();

  const value = useMemo(
    () => ({
      enabled: isEnabled('levels'),
    }),
    [isEnabled]
  );
  return value;
};
